import { render, staticRenderFns } from "./Urgency.vue?vue&type=template&id=1e26725a"
import script from "./Urgency.vue?vue&type=script&lang=ts"
export * from "./Urgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports